import { Box, Stack, Typography } from "@mui/material";
import { getTimeframeTimeDisplayText } from "../../../../common/utilities/TimeframeUtilities";
import { TimeframeTypeEnum } from "../../../../common/enums/TimeframeTypeEnum";
import { UserAndRoleAdministrationUser } from "../../../../services/user-role-administration-service/Models";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import type { JSX } from "react";

export type UserSubheaderProps = {
    user: UserAndRoleAdministrationUser;
};

export default function UserSubheader({
    user
}: UserSubheaderProps): JSX.Element {

    const { t } = useTranslation();
    
    const lastActivityTimestamp = user.lastActivityTimestamp
        ? getTimeframeTimeDisplayText(TimeframeTypeEnum.None, user.lastActivityTimestamp)
        : "None";

    function getDisabledText() {

        return user.notificationDisableSettings ? user.notificationDisableSettings.forwardToRecipient ?
            t('userRoleAdministration.tabs.users.notificationsForwarded', {
                recipient: user.notificationDisableSettings.forwardToRecipient.to,
                timestamp: format(new Date(user.notificationDisableSettings.schedule.end), "P pp")
            }) :
            t('userRoleAdministration.tabs.users.notificationsDisabled', {
                timestamp: format(new Date(user.notificationDisableSettings.schedule.end), "P pp")
            }) :
            undefined;
    }

    return (
        <>
            <Stack direction="row">
                {user.jobDescription &&
                    <Box
                        sx={{
                            color: "primary",
                            fontStyle: "italic",
                            flex: "1 1 auto"
                        }}>
                        {`${user.jobDescription}`}
                    </Box>
                }

                {lastActivityTimestamp &&
                    <Box>
                        {`Last Activity: ${lastActivityTimestamp}`}
                    </Box>
                }

            </Stack>
            {
                user.notificationDisableSettings &&
                <Stack direction="row" sx={{
                    marginTop: 1
                }}>
                    <Typography variant="body2" style={{ color: "green", fontStyle: "italic" }}>
                        {getDisabledText()}
                    </Typography>
                </Stack>
            }
        </>
    );
}
